import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  HostListener,
  Output,
  EventEmitter,
} from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { GradeLevel } from '@app/infrastructure/models/grade-level';
import { INavigation } from '@models/navigation';

@Component({
  selector: 'app-grades-selector-presentation',
  templateUrl: './grades-selector-presentation.component.html',
  styleUrls: ['./grades-selector-presentation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GradesSelectorPresentationComponent implements OnInit {
  @Input() public gradeLevelList: INavigation[] = [];
  @Input() public headerStyle: boolean = false;
  @Input() public routeOnClick: boolean = true;
  @Input() public selectedGrade: number = null;
  @Output() public gradeSelection = new EventEmitter<number>();

  gradeHover: string[] = [];
  public getScreenWidth: any;
  public getScreenHeight: any;

  ngOnInit(): void {
    this.getScreenWidth = window.innerWidth;
    this.getScreenHeight = window.innerHeight;
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    this.getScreenWidth = window.innerWidth;
    this.getScreenHeight = window.innerHeight;
  }

  trackBy(index: number, name: INavigation): number {
    return name.id;
  }

  getIsHeaderStyle() {
    if (this.getScreenWidth < 1280 || this.headerStyle) return true;
    return false;
  }

  isSelected(id: number): boolean {
    return this.selectedGrade === id;
  }

  mouseEnter(id: string) {
    this.gradeHover.push(id);
  }

  mouseLeave(id: string) {
    const index = this.gradeHover.indexOf(id);
    if (index > -1) {
      this.gradeHover.splice(index, 1);
    }
  }

  mouseDown(id: string) {
    // this.gradeSelection.emit(parseInt(id, 10));
    // this.gradeSelected = [];
    // this.gradeSelected.push(id);
    // localStorage.setItem('STEMTaughtGradeSelection', id);
  }

  hover(id: string): boolean {
    return this.gradeHover.indexOf(id) > -1;
  }

  colorize(str: string): string {
    let style: string = 'backsplash--';
    switch (str) {
      case GradeLevel.KINDERGARTEN:
        style += 'lemon';
        break;
      case GradeLevel.FIRST:
        style += 'lava';
        break;
      case GradeLevel.SECOND:
        style += 'lavender';
        break;
      case GradeLevel.THIRD:
        style += 'sky';
        break;
      case GradeLevel.FOURTH:
        style += 'lemon';
        break;
      case GradeLevel.FIFTH:
        style += 'tropical';
        break;
      case GradeLevel.SIXTH:
        style += 'citrus';
        break;
    }

    return style;
  }
}
